export default {
  data(){
    return {
      isToolbarTouching : false,
      toolbarPosition   : 'default',

      editorMetaClass   : {
        'editor-form-meta-up-mobile-keyboard'  : false,
        'editor-form-meta-hidden'              : false,
      },
    };
  },

  watch : {
    toolbarPosition(value){
      if(this.isToolbarTouching) return;

      switch(value){
        case 'default':
          this.setToolbarPositionDown();
        break;

        case 'up':
          this.setToolbarPositionUp();
        break;
      }
    },

    isEditorLoading(value){
      if(value === true){
        this.editorMetaClass['editor-form-meta-hidden'] = true;
      }else{
        this.editorMetaClass['editor-form-meta-hidden'] = false;
      }
    }
  },

  methods : {
    handleScroll(){
      document.querySelector('.editor-form-meta-up-mobile-keyboard').style.top = window.pageYOffset + 'px';
    },

    setToolbarPositionUp(){
      this.editorMetaClass['editor-form-meta-up-mobile-keyboard'] = true;

      window.addEventListener('scroll', this.handleScroll);

      this.inkCountBannerPopperArrowPosition = 'bottom';

      this.$nextTick(() => {
        this.calcEditorHeight();
      });
    },

    setToolbarPositionDown(){
      this.editorMetaClass['editor-form-meta-up-mobile-keyboard'] = false;

      window.removeEventListener('scroll', this.handleScroll);

      this.inkCountBannerPopperArrowPosition = 'top';

      this.$nextTick(() => {
        this.calcEditorHeight();
      });
    },

    handleTouchStartEvent(){
      this.isToolbarTouching = true;
    },

    handleTouchEndEvent(){
      setTimeout(() => {
        this.isToolbarTouching = false;
      }, 500);
    }
  },

  mounted(){
    this.$refs.editorMeta.addEventListener('touchstart', this.handleTouchStartEvent);

    this.$refs.editorMeta.addEventListener('touchend', this.handleTouchEndEvent);
  },

  beforeDestroy(){
    this.$refs.editorMeta.removeEventListener('touchstart', this.handleTouchStartEvent);
    this.$refs.editorMeta.removeEventListener('touchend', this.handleTouchEndEvent);
  }
}